import gsap from 'gsap';
import { getLastKeyframeFrame } from './timeline';
/**
 * Editor timeline verisine göre playhead'i GSAP timeline ile ilerletir.
 * Kare güncellemeleri mevcut TimelineFrames interpolasyonunu (tween/KeyframeState) tetikler.
 */
export function createEditorPlaybackTimeline(options) {
    const { keyframes, totalFrames, startFrame, fps, setFrame, onComplete } = options;
    const lastKf = getLastKeyframeFrame(keyframes);
    if (lastKf === null) {
        onComplete();
        return null;
    }
    const playEnd = Math.min(lastKf, Math.max(0, totalFrames - 1));
    if (startFrame >= playEnd) {
        setFrame(playEnd);
        onComplete();
        return null;
    }
    const proxy = { p: 0 };
    const span = playEnd - startFrame;
    const tl = gsap.timeline({ onComplete }).to(proxy, {
        p: 1,
        duration: span / fps,
        ease: 'none',
        onUpdate: () => {
            const t = proxy.p >= 1 ? 1 : proxy.p;
            const frame = Math.round(startFrame + t * span);
            setFrame(Math.min(playEnd, Math.max(startFrame, frame)));
        },
    });
    return tl;
}
